module.exports = __webpack_public_path__ + "static/img/user.9a4989e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/aboutGolday/img/user.jpg
// module id = T44T
// module chunks = 1